module.exports = __webpack_public_path__ + "ed3311dd4aaf4c961ecc8ca8939c8a5d.jpg";